export default __webpack_public_path__ + "static/media/image2.8e92aee5.jpg";